import { SharedStyles } from '@opencare/shared-styles';
import { IconLock } from '@tabler/icons-react';
import { styled } from 'styled-components';

import { TYPOGRAPHY } from 'brand-guidelines/typography';

export const SecurityTextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: center;
  margin-top: 8px;
  padding: 4px 12px;
  border-radius: 16px;
  background: rgba(222, 241, 237, 0.82);
`;

export const SecurityTextContent = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  ${TYPOGRAPHY.OPEN_SANS.semiBold};
  color: ${SharedStyles.COLOR.TEXT.PRIMARY.DEFAULT};
`;

export const LockIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

export const StyledIconLock = styled(IconLock)`
  width: 16px;
  height: 16px;
  color: ${SharedStyles.COLOR.ICON.PRIMARY.DEFAULT};
`;
